<template>
	<div
		class="infinity-scroll-container"
		ref="infinityScrollContainer"
		:class="className"
		:style="{ 'max-height': `${maxHeightInfinityScroll}px` }"
		@scroll="handleScroll"
	>
		<component
			:is="componentData.component.is"
			v-bind="componentData.component.props"
		/>
	</div>
</template>
<script>
import _ from 'lodash';

export default {
	name: 'InfiniteScroll',
	props: {
		componentData: {
			type: Object,
			default: () => {}
		},
		className: {
			type: String,
			default: ''
		},
		extraHeightInfinityScroll: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			maxHeightInfinityScroll: 0,
			scrollEnd: false,
			scrollLock: false
		};
	},
	methods: {
		handleScroll(el) {
			const margen = 5; //before reaching bottom
			this.scrollEnd =
				el.srcElement.offsetHeight + el.srcElement.scrollTop + margen >=
				el.srcElement.scrollHeight;

			this.scrollLock = this.scrollEnd;
		},
		calculateDivMaxHeight(includeMargin = true) {
			let main = _.get(
				this,
				this.componentData.mainPath + '.contentPageMain'
			);

			let appClientHeightValue =
				this.componentData.parentPath + '.app.clientHeight';
			let appHeaderValue =
				this.componentData.parentPath + '.appHeader.offsetHeight';
			let appFooterValue =
				this.componentData.parentPath + '.appFooter.offsetHeight';

			if (main) {
				main.scrollTop = 0;
				const appClientHeight = Math.ceil(
					_.get(this, appClientHeightValue, 0)
				);

				let appHeader = Math.ceil(_.get(this, appHeaderValue, 0));
				if (includeMargin) {
					appHeader += 8; //site__header margin
				}
				let appFooter = Math.ceil(_.get(this, appFooterValue, 45));
				if (includeMargin) {
					appFooter += 12; //site__main margin
				}

				this.maxHeightInfinityScroll = Math.ceil(
					appClientHeight -
						appFooter -
						appHeader -
						this.extraHeightInfinityScroll || 0
				);

				this.$emit('calculateDivMaxHeight', {
					maxHeightInfinityScroll: this.maxHeightInfinityScroll,
					scrollHeight: main.$el.scrollHeight
				});
			}
		},
		setScrollTopToZero() {
			this.$refs.infinityScrollContainer.scrollTop = 0;
		}
	},
	watch: {
		extraHeightInfinityScroll: {
			immediate: true,
			handler(val) {
				if (val) {
					this.calculateDivMaxHeight();
				}
			}
		},
		scrollEnd: {
			handler(val) {
				this.$emit('scrollEnd', val);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
/**
	* Infinity Scroll
	* Can use SCSS variables = TRUE
*/

.infinity-scroll-container {
	overflow-y: auto;
	@include scrollbar;
}
</style>
